import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'math_map',
    colour: CATEGORIES.operator.color,
    tooltip: '値の範囲を別の範囲に変換します',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () =>
                        new FieldStyledLabel('MAP', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'value',
            name: 'VALUE',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'を' }],
        },
        {
            kind: 'value',
            name: 'FROM_LOW',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('～', { fontSize: 13, fontWeight: 'medium' }),
                },
            ],
        },
        {
            kind: 'value',
            name: 'FROM_HIGH',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 1023 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'の範囲から' }],
        },
        {
            kind: 'value',
            name: 'TO_LOW',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('～', { fontSize: 13, fontWeight: 'medium' }),
                },
            ],
        },
        {
            kind: 'value',
            name: 'TO_HIGH',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 100 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'の範囲に置き換えた数値　' }],
        },
    ],
});
